import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { Async } from 'react-select';
import 'react-select/dist/react-select.css';

import classname from 'classname';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';

const SelectField = props => {
	const className = classname({
		'form-element': true,
		'active': isActive(props),
		'has-error': hasError(props),
		[props.className]: !!props.className
	});

	const selectProps = {
		name: props.name,
		placeholder: '',
		options: props.options,
		loadOptions: props.loadOptions,
		searchable: !!props.searchable,
		clearable: !!props.clearable,
		disabled: props.shouldDisable,
		onBlur: () => props.input.onBlur(props.input.value),
		className: 'form-element__control font-proxima-nova-regular',
		autoFocus: !!props.autoFocus,
		openOnFocus: !!props.openOnFocus
	};

	return (
		<div className={className}>
			{props.children}
			<label className="form-element__label" htmlFor={props.input.name}>
				{hasError(props) ? `${props.placeholder} (${errorValue(props)})` : props.placeholder}
			</label>
			{/* noop filterOptions needed because we already filter them on server side */}
			{ isFunction(selectProps.loadOptions) ?
				<Async {...props.input} {...selectProps} filterOptions={options => options} /> :
				<Select {...props.input} {...selectProps} />
			}
		</div>
	);
};

SelectField.propTypes = {
	name: PropTypes.string,
	placeholder: PropTypes.string,
	meta: PropTypes.object,
	input: PropTypes.object,
	options: PropTypes.array,
	loadOptions: PropTypes.func,
	clearable: PropTypes.bool,
	searchable: PropTypes.bool,
	className: PropTypes.string,
	onBlur: PropTypes.func,
	shouldDisable: PropTypes.bool,
	children: PropTypes.node,
	autoFocus: PropTypes.bool,
	openOnFocus: PropTypes.bool
};

const isActive = props => props.meta.active || props.input.value || !isEmpty(props.input.value);
const hasError = props => props.meta.touched && props.meta.error;
const errorValue = props => {
	return props.meta.error;
};

export default SelectField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/select.js